var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"f8e403d0e6c35208d5952354e198cba35a6fbeeb"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN: string =
  process.env.SENTRY_DSN ?? process.env.NEXT_PUBLIC_SENTRY_DSN ?? '';

const RAW_IGNORE_ERRORS: string = process.env.NEXT_PUBLIC_IGNORE_ERRORS ?? '';

let ignoreErrors: string[] = [];

try {
  ignoreErrors = (JSON.parse(RAW_IGNORE_ERRORS) as string[]).filter(
    (ignoreError) => typeof ignoreError === 'string'
  );
} catch (error) {
  ignoreErrors = [];
}

function isWalletProviderOnNoiseFromExtension(event: Sentry.Event): boolean {
  const first = event.exception?.values?.[0];
  const msg = first?.value ?? event.message ?? '';
  if (!msg.includes('.on is not a function')) {
    return false;
  }
  const frames = first?.stacktrace?.frames ?? [];
  const paths = frames
    .map((f) => [f.filename, f.abs_path].filter(Boolean).join(' '))
    .join(' ');
  return /chrome-extension:|moz-extension:|extensionpagescript|injected\.js|inpage\.js/i.test(
    paths
  );
}

function isWalletExtensionSendMessageNoise(event: Sentry.Event): boolean {
  const values = event.exception?.values ?? [];

  return values.some((exception) => {
    const msg = exception.value ?? event.message ?? '';
    if (!msg.includes("Cannot read properties of undefined (reading 'sendMessage')")) {
      return false;
    }

    const frames = exception.stacktrace?.frames ?? [];
    return frames.some((frame) =>
      /injectedScript\.bundle\.js|chrome-extension:|moz-extension:/i.test(
        [frame.filename, frame.abs_path].filter(Boolean).join(' ')
      )
    );
  });
}

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NODE_ENV,
  ignoreErrors,
  beforeSend(event) {
    if (
      isWalletProviderOnNoiseFromExtension(event) ||
      isWalletExtensionSendMessageNoise(event)
    ) {
      return null;
    }
    return event;
  },
  tracesSampler: (samplingContext) =>
    samplingContext.transactionContext.op === 'EventLog' ||
    samplingContext.transactionContext.op === 'MarketingEvent'
      ? 1.0
      : 0.0,
});
